<script lang="ts" setup>
import { ButtonStyle } from '~/static/enums/components/button'
import AButton from '~/components/atoms/buttons/Button.vue'
import RModal from '~/components/organs/Modal.vue'
import ACustomSelect from '~/components/atoms/forms/CustomSelect.vue'
import { closeModal } from '~/utils/Modal'
import { Directory } from '~/static/types/directories'

interface Props {
  directories: Directory[]
  directoryId: number | null
  cardName: string
}

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'put', name: number | null): void
}>()

const localDirectoryId = ref<number | null>(props.directoryId)
const selectDirectory = (value: number | null) => {
  if (value === null) {
    emit('put', null)
    closeModal()
    return
  }
  localDirectoryId.value = value
}
const put = () => {
  emit('put', localDirectoryId.value)
  closeModal()
}
const cancel = () => {
  closeModal()
}

const options = computed(() => {
  return props.directories.map((directory) => {
    return {
      value: directory.id,
      text: directory.name,
    }
  })
})

</script>

<template>
  <RModal
    ref="refModal"
    name-modal="nameChangeModal"
    @close="cancel"
  >
    <template #header>
      <h5
        class="modal-title fs-5"
        id="nameChangeModalLabel"
      >
        Карточка «{{ cardName }}»
      </h5>
    </template>

    <template #body>
      <div
        v-if="directories.length > 0"
        class="body"
      >
        <span class="d-block mb-2">Переместить в папку:</span>
        <ACustomSelect
          placeholder="Выбрать папку"
          class="mb-lg-5"
          :selected="localDirectoryId"
          :options="options"
          @change="selectDirectory"
        />
      </div>
      <div
        v-else
        class="body"
      >
        <span class="d-block mb-lg-2">Создайте папку, чтобы переместить карточку</span>
      </div>
    </template>
    <template #footer>
      <AButton
        v-if="directories.length > 0"
        :button-style="ButtonStyle.Primary"
        @click="put"
      >
        Переместить
      </AButton>
      <AButton
        v-else
        :button-style="ButtonStyle.Primary"
        @click="put"
      >
        Создать папку
      </AButton>
    </template>
  </RModal>
</template>

<style lang="scss" scoped>
.body {
  width: 100%;
}

:deep(.select-group) {
  @include media-breakpoint-down(lg) {
    .items {
      top: auto;
      bottom: calc(100% + 2px);
    }
  }
}
</style>
